import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Landmark, User } from 'lucide-react';
const audiences = [{
  title: 'Empresas',
  description: 'Movilidad de empleados, visados, permisos y compliance corporativo.',
  icon: <Building2 className="w-10 h-10 text-white" data-id="element-1" />,
  color: 'bg-navy',
  cta: 'Soluciones para empresas'
}, {
  title: 'Administración',
  description: 'Documentación, soporte técnico y gestión de procedimientos administrativos.',
  icon: <Landmark className="w-10 h-10 text-white" data-id="element-2" />,
  color: 'bg-steel',
  cta: 'Servicios públicos'
}, {
  title: 'Particulares',
  description: 'Residencia, nacionalidad, visados y trámites personales sin estrés.',
  icon: <User className="w-10 h-10 text-white" data-id="element-3" />,
  color: 'bg-primary',
  cta: 'Ayuda para particulares'
}];
export function Audience() {
  return <section className="py-20 bg-white" data-id="element-4">
      <div className="container mx-auto px-4 md:px-6" data-id="element-5">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-6">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-7">
            Adaptados a tus necesidades
          </h2>
          <p className="text-lg text-gray-600" data-id="element-8">
            Ofrecemos un servicio personalizado según tu perfil y objetivos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-9">
          {audiences.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative overflow-hidden rounded-2xl group cursor-pointer" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-10">
              <div className={`absolute inset-0 ${item.color} opacity-90 transition-opacity group-hover:opacity-100`} data-id="element-11"></div>
              <div className="relative p-8 h-full flex flex-col items-center text-center text-white min-h-[300px] justify-center" data-id="element-12">
                <div className="mb-6 p-4 rounded-full bg-white/10 backdrop-blur-sm group-hover:scale-110 transition-transform duration-300" data-id="element-13">
                  {item.icon}
                </div>
                <h3 className="text-2xl font-bold mb-3" data-id="element-14">{item.title}</h3>
                <p className="text-white/80 mb-8 leading-relaxed" data-id="element-15">
                  {item.description}
                </p>
                <span className="inline-flex items-center font-medium border-b border-white/30 pb-1 group-hover:border-white transition-colors" data-id="element-16">
                  {item.cta}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}